import Predpisy from './Predpisy';

export default Predpisy;
